var render = function () {
  var _vm$getEventData$part, _vm$getEventData$part2, _this$getEventData, _this$getEventData2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('vue-title', {
    attrs: {
      "title": ((_vm.getEventData.name) + " - Event")
    }
  }), _c('div', {
    staticClass: "homepage-wrap clearfix"
  }, [_c('div', {
    staticClass: "section-wrap bg-img event-more"
  }, [_c('div', {
    staticClass: "max-width-wrap"
  }, [_c('div', {
    staticClass: "event-more-wrapper"
  }, [_c('div', {
    staticClass: "txt-wrapper"
  }, [_c('h2', {
    staticClass: "heading-lrg"
  }, [_c('span', [_vm._v(_vm._s(_vm.getEventData.name))])])])])])]), _c('div', {
    staticClass: "bg-img register-now mb-10"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "register-box"
  }, [_c('div', {
    staticClass: "div-flex"
  }, [_c('div', {
    staticClass: "col-right"
  }, [_c('div', {
    staticClass: "div-flex"
  }, [_vm.getEventData.date ? _c('div', {
    staticClass: "col-right"
  }, [_c('div', {
    staticClass: "regi-block txt-center",
    class: _vm.getEventData.prizeMoney ? 'border-right' : ''
  }, [_c('h5', [_vm._v(" " + _vm._s(_vm.getEventData.date) + " ")]), _c('span', [_vm._v("Event Date")])])]) : _vm._e(), _vm.getEventData.prizeMoney ? _c('div', {
    staticClass: "col-right"
  }, [_c('div', {
    staticClass: "regi-block txt-center"
  }, [_c('h5', [_vm._v(_vm._s(_vm.getEventData.prizeMoney))]), _c('span', [_vm._v("Prize Money")])])]) : _vm._e()])]), _c('div', {
    staticClass: "col-right"
  }, [_vm.checkJoinStatus() && _vm.getEventData.accept ? _c('a', {
    staticClass: "btn-regi",
    staticStyle: {
      "color": "#0a0a0a"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function ($event) {
        return _vm.joinEvent(_vm.getEventData.id);
      }
    }
  }, [_vm._v("REGISTER NOW!")]) : _vm._e()])])]), _vm.loggedIn ? _c('p', {
    staticClass: "p-text p-text-small"
  }, [_vm.getEventData.accept ? [_vm.getEventData.ustatus === 'pending' ? [_c('p', {
    staticClass: "alert alert-warning alert-12"
  }, [_vm._v(" Your registration for this event is in process, soon you will receive a confirmation email. ")])] : _vm.getEventData.ustatus === 'approved' ? [_c('p', {
    staticClass: "alert alert-success alert-12"
  }, [_vm._v(" Congratulations! Your registration for this event has been approved. ")])] : _vm.getEventData.ustatus === 'declined' ? [_c('p', {
    staticClass: "alert alert-danger alert-12"
  }, [_vm._v(" Your request for this event is declined. please contact support for further details ")])] : [_vm.join && _vm.checkEmptySlots() ? _c('span', [_vm._v("Registration closing at: " + _vm._s(_vm.getEventData.date_close) + " at " + _vm._s(_vm.getEventData.time_close) + " GMT +4")]) : _vm._e(), !_vm.checkEmptySlots() ? _c('span', [_vm._v(" The room is already fill for this event. ")]) : _vm._e()]] : [_c('span', [_vm._v(" Registration for this event has been closed. ")])]], 2) : _c('p', {
    staticClass: "p-text p-text-small"
  }, [_vm._v(" Login or create an account to register for this event. ")])])]), _c('div', {
    staticClass: "card-box-info"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "/assets/images/icon-1.png"
    }
  }), _c('span', [_vm._v("Distance")]), _c('div', {
    staticClass: "count-text"
  }, [_vm._v(_vm._s(_vm.getEventData.distance))])]), _c('li', [_c('img', {
    attrs: {
      "src": "/assets/images/icon-2.png"
    }
  }), _c('span', [_vm._v("Race Starting Time")]), _c('div', {
    staticClass: "count-text"
  }, [_vm._v(" " + _vm._s(_vm.getEventData.time) + " "), _c('span', {
    staticClass: "gmt-css"
  }, [_vm._v("GMT +4")])])]), _c('li', [_c('img', {
    attrs: {
      "src": "/assets/images/icon-3.png"
    }
  }), _c('span', [_vm._v("Total Elevation")]), _c('div', {
    staticClass: "count-text"
  }, [_vm._v(_vm._s(_vm.getEventData.elevation))])]), _vm.getEventData.maxGrade ? _c('li', [_c('img', {
    attrs: {
      "src": "/assets/images/icon-4.png"
    }
  }), _c('span', [_vm._v("Max Grade")]), _c('div', {
    staticClass: "count-text"
  }, [_vm._v(_vm._s(_vm.getEventData.maxGrade))])]) : _vm._e(), _c('li', [_c('img', {
    attrs: {
      "src": "/assets/images/icon-5.png"
    }
  }), _c('span', [_vm._v("Participant")]), _c('div', {
    staticClass: "count-text"
  }, [_vm._v(" " + _vm._s((_vm$getEventData$part = _vm.getEventData.participants) === null || _vm$getEventData$part === void 0 ? void 0 : _vm$getEventData$part.booked) + " / " + _vm._s((_vm$getEventData$part2 = _vm.getEventData.participants) === null || _vm$getEventData$part2 === void 0 ? void 0 : _vm$getEventData$part2.capacity) + " ")])])])])]), _c('div', {
    staticClass: "text-info"
  }, [_c('div', {
    staticClass: "container",
    domProps: {
      "innerHTML": _vm._s(_vm.getEventData.details)
    }
  })]), _c('EventCategoryTimes', {
    attrs: {
      "data": _vm.getEventData,
      "details": true,
      "new_version": true
    }
  }), _c('EventLinks', {
    attrs: {
      "links": _vm.getLinks,
      "new_version": true
    }
  }), _c('br'), _vm.getEventData.map ? _c('div', {
    staticClass: "elevation"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": _vm.makeImage(_vm.getEventData.map, 1800, 1024, true)
    }
  })])]) : _vm._e()], 1), (_this$getEventData = this.getEventData) !== null && _this$getEventData !== void 0 && _this$getEventData.event_prize_money ? _c('PriceWidget', {
    attrs: {
      "winners": (_this$getEventData2 = this.getEventData) === null || _this$getEventData2 === void 0 ? void 0 : _this$getEventData2.event_prize_money,
      "eventData": _vm.getEventData,
      "showLink": false
    }
  }) : _vm._e(), _vm._m(0)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-bar-wrap"
  }, [_c('div', {
    staticStyle: {
      "--scroll": "0%"
    },
    attrs: {
      "id": "progress-bar"
    }
  })]);
}]

export { render, staticRenderFns }